export class PartyDto {
  id: string;
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  dateCreated: Date;
  Version: Number;
  PartyName: string;
  PartyGroup: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  }
